var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint0_linear_5609_27040)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5609_27040)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 26.5C41.1004 26.5 38.75 28.8505 38.75 31.75H49.25C49.25 28.8505 46.8996 26.5 44 26.5ZM52.75 31.75C52.75 26.9175 48.8325 23 44 23C39.1675 23 35.25 26.9175 35.25 31.75H23V35.25H26.5V65H61.5V35.25H65V31.75H52.75ZM35.8328 42.25V54.5H39.3328V42.25H35.8328ZM48.6655 42.25V54.5H52.1655V42.25H48.6655Z",
    fill: "url(#paint1_linear_5609_27040)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5609_27040",
    x1: 0,
    y1: 0,
    x2: 88,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5609_27040",
    x1: 44,
    y1: 23,
    x2: 44,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5609_27040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDelete);
export default __webpack_public_path__ + "static/media/user-delete.b6d860da0eba19660e4f4dcd8c485850.svg";
export { ForwardRef as ReactComponent };